
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products/[name]",
      function () {
        return require("private-next-pages/products/[name].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/products/[name]"])
      });
    }
  